// Pure, dependency-free CSV helpers for in-browser exports.
//
// No CSV/download pattern existed in the frontend before this; keep these
// generic so other list screens can reuse them rather than re-rolling escaping.

// RFC-4180-ish field escaping: wrap in double quotes and double any embedded
// quote whenever the value contains a comma, quote, CR or LF. null/undefined
// render as empty. Everything else is stringified as-is.
function escapeField(value) {
  const s = value == null ? '' : String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/**
 * Build a CSV string from a header row and an array of row arrays.
 * Prepends a UTF-8 BOM so Excel opens accented text correctly.
 * @param {string[]} headers
 * @param {Array<Array<*>>} rows
 * @returns {string}
 */
export function toCSV(headers, rows) {
  const BOM = '﻿'; // makes Excel detect UTF-8
  const lines = [headers, ...rows].map(cols => cols.map(escapeField).join(','));
  return BOM + lines.join('\r\n');
}

/**
 * Trigger a client-side download of `text` as `filename`.
 * @param {string} filename
 * @param {string} text
 * @param {string} [mime]
 */
export function downloadCSV(filename, text, mime = 'text/csv;charset=utf-8') {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
